export default "__VITE_ASSET__7dboGfBp__"